// eslint-disable-next-line import/no-restricted-paths
import { useCurrentAccountQuery } from "../../api/queries/useAccountQuery";

const UnderFeatureFlag = ({ feature, children }) => {
  const { data } = useCurrentAccountQuery();

  const enabledFeature = data?.globalSettings?.featureFlag?.[feature];

  return enabledFeature ? children : null;
};

export default UnderFeatureFlag;
